import {useEffect} from "react";
import PropTypes from "prop-types";
import {GlobalNavigate} from "../../../../Helpers";

export const RedirectionSection = ({redirectPath}) => {
  useEffect(() => {
    GlobalNavigate(`/${redirectPath}`);
  }, [redirectPath]);

  return null;
};

RedirectionSection.propTypes = {
  redirectPath: PropTypes.string.isRequired,
};
